// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__Lw1P0","va-primary":"Tabs_va-primary__UOwcv"};